import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedYearMonth} from '../helper/NatBicycleParkingUseWithdrawalApplyHelper'
import {getFormattedDate} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    withdrawalArea: Nullable<string>
    withdrawalDate: Nullable<string>
    bicycleCarryingOutDate: Nullable<string>
    applyFlag?: boolean
}

const NatResidentBicycleParkingUseWithdrawalConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {applicantFamilyName, applicantFirstName, withdrawalArea, withdrawalDate, bicycleCarryingOutDate} = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.BICYCLE_PARKING_USE_ADMIT_CANCEL.label

    const withdrawalAreaLabel = withdrawalArea ?? ''

    const withdrawalDateLabel = (withdrawalDate) ? getFormattedYearMonth(withdrawalDate) : ''

    const bicycleCarryingOutDateLabel = (bicycleCarryingOutDate) ? getFormattedDate(bicycleCarryingOutDate) : ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (
        <>
            {applyFlag === true &&
                <>
                    <NatResidentApplicationDetailConfirmItem
                        title={'申請区分'}
                        items={[applyCategoryLabel]}
                    />
                    <BlockSpacer height={'5px'}/>
                    <NatResidentApplicationDetailConfirmItem
                        title={'申請者'}
                        items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                    />
                </>
            }
            <BlockSpacer height={'5px'}/>
            <NatResidentApplicationDetailConfirmItem
                title={'解除する区画'}
                items={[withdrawalAreaLabel]}
            />
            <BlockSpacer height={'5px'}/>
            <NatResidentApplicationDetailConfirmItem
                title={'解除日'}
                items={[withdrawalDateLabel]}
            />
            <BlockSpacer height={'5px'}/>
            <NatResidentApplicationDetailConfirmItem
                title={'自転車搬出日'}
                items={[bicycleCarryingOutDateLabel]}
            />
        </>)
}

NatResidentBicycleParkingUseWithdrawalConfirm.displayName = 'NatResidentBicycleParkingUseWithdrawalConfirm'
export default NatResidentBicycleParkingUseWithdrawalConfirm

